import * as React from "react";

import SelectFilter from "../../Base/CompleteList/Filters/SelectFilter";

export default ({ column }) => {
  const choices = [
    { value: "leasecontract", display: "Förvaltningsavtal" },
    { value: "other", display: "Övrigt" },
  ];

  return <SelectFilter choices={choices} column={column} />;
};
